<template lang="pug">
    
Card(
    :class="styles.root"
    padding="orange"
)
    Qr(
        :text="url"
        :class="styles.qr"
    )
    ImageSvg(
        :class="styles.logo"
        src="/images/common/elqr-logo.svg"
        alt="elqr logo"
        height="28"
        width="auto"
    )
    
        
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

import { Card } from '@/shared/ui/Card'
import { ImageSvg } from '@/shared/ui/ImageSvg'
import { useAppStore } from '@/shared/model'
import { Qr } from '@/shared/ui/Qr'

export default Vue.extend({
    name: 'QrCard',
    setup() {
        const styles = useCssModule()

        const {
            state: { url },
        } = useAppStore()

        return {
            styles,
            url,
        }
    },
    components: {
        Qr,
        ImageSvg,
        Card,
    },
})
</script>

<style module lang="scss" src="./QrCard.module.scss" />
